import {
  Box,
  Flex,
  Highlight,
  HStack,
  StackProps,
  Text,
  TextProps,
} from "@chakra-ui/react";
import { Link } from "@areahub/ui/components/link/link";
import { LinkBox } from "@areahub/ui/components/link/link-box";
import Image from "next/image";
import { useAtomValue } from "jotai";
import { highlightedSearchAtom } from "../filter-bar";
import { ImageFragment } from "./media";

// import { PlaceholderImage } from "typings/gcms-typings";

export interface BlogAuthorProps extends StackProps {
  image: string;
  name: string;
  meta: string;
  url: string;
  tagSx?: TextProps;
  placeholderImage?: ImageFragment & { alt?: string };
}

export const Author = (props: BlogAuthorProps) => {
  const {
    image,
    name,
    meta,
    url,
    tagSx,
    m,
    mx,
    my,
    mt,
    mb,
    mr,
    ml,
    placeholderImage,
    color,
    ...rest
  } = props;
  const highlight = useAtomValue(highlightedSearchAtom);

  return (
    <LinkBox {...{ m, mx, my, mt, mb, mr, ml }}>
      <HStack spacing="4" {...rest}>
        {placeholderImage ? (
          <Box
            h="10"
            w="10"
            position="relative"
            rounded="full"
            overflow="hidden"
          >
            <Image
              src={placeholderImage.url}
              alt={placeholderImage?.alt ?? placeholderImage?.handle}
              {...placeholderImage}
            />
          </Box>
        ) : (
          <Image
            style={{
              objectFit: "cover",
              borderRadius: "100%",
            }}
            height="40"
            width="40"
            alt={name}
            src={image}
          />
        )}
        <Flex direction="column">
          <Link
            href={url}
            color={color ?? "black"}
            fontWeight="semibold"
            fontSize="sm"
            _hover={{
              textDecoration: "underline",
            }}
            isOverlay
          >
            <Highlight
              query={highlight}
              styles={{
                px: "0.5",
                py: "0.75",
                borderRadius: "md",
                bg: "orange.100",
              }}
            >
              {name}
            </Highlight>
          </Link>
          <Text fontSize="sm" color="gray.500" {...tagSx}>
            {meta}
          </Text>
        </Flex>
      </HStack>
    </LinkBox>
  );
};
